import { Dialog, DialogTitle, DialogContent, Grid2, DialogActions, Button } from '@mui/material';
import React, { useEffect } from 'react';
import { SimpleFormField, SimpleFormPropertyType, SimpleFormTemplateProperty, useSimpleForm } from '../../../components/SimpleForm';
import { ResourceListItem } from '../../../types';

const EDIT_MATERIAL_FORM_TEMPLATE: SimpleFormTemplateProperty<ResourceListItem>[] = [{
	name: 'name',
	label: 'Name',
	type: SimpleFormPropertyType.String,
	required: true
},{
	name: 'description',
	label: 'Secondary text',
	type: SimpleFormPropertyType.String,
},{
	name: 'quantity',
	label: 'Quantity',
	type: SimpleFormPropertyType.Number,
	required: true
},{
	name: 'isOptional',
	label: 'Is optional',
	type: SimpleFormPropertyType.Toggle,
}];

interface PlanEditMaterialDialogProps {
	open: boolean;
	onClose: () => void;
	onSubmit: (formData: Partial<ResourceListItem>) => void;
	item: ResourceListItem | null;
}

interface PlanEditToolDialogProps {
	open: boolean;
	onClose: () => void;
	onSubmit: (formData: Partial<ResourceListItem>) => void;
	item: ResourceListItem | null;
}

export function PlanMaterialEditDialog({ open, onClose, onSubmit, item }: PlanEditMaterialDialogProps) {
	const {getFormData, resetFormData, handleFormFieldChange, hasFormChanged} = useSimpleForm<ResourceListItem>(EDIT_MATERIAL_FORM_TEMPLATE);
	
	useEffect(() => {
		if (item) {
			resetFormData(item);
		}
	}, [item]);

	const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		const formData = getFormData(e);
		onSubmit({...formData, id: item?.id});
		onClose();
	};

	return <Dialog open={open} onClose={onClose}>
		<DialogTitle>Edit material</DialogTitle>
		<form onSubmit={handleSubmit}>
			<DialogContent>
				<Grid2 size={12} container spacing={1} alignContent='baseline'>
					{EDIT_MATERIAL_FORM_TEMPLATE.map((property) => <Grid2 key={property.name} size={12}>
						<SimpleFormField property={property} defaultValue={item?.[property.name]} onChange={handleFormFieldChange} />
					</Grid2>)}
				</Grid2>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Cancel</Button>
				<Button type='submit' disabled={!hasFormChanged} variant='contained'>Save</Button>
			</DialogActions>
		</form>
	</Dialog>;
}

export function PlanToolEditDialog({ open, onClose, onSubmit, item }: PlanEditToolDialogProps) {
	const EDIT_TOOL_FORM_TEMPLATE: SimpleFormTemplateProperty<ResourceListItem>[] = [{
		name: 'name',
		label: 'Name',
		type: SimpleFormPropertyType.String,
		required: true,
		disabled: !!item?.toolId
	},{
		name: 'description',
		label: 'Secondary text',
		type: SimpleFormPropertyType.String,
	},{
		name: 'quantity',
		label: 'Quantity',
		type: SimpleFormPropertyType.Number,
		required: true
	},{
		name: 'isOptional',
		label: 'Is optional',
		type: SimpleFormPropertyType.Toggle,
	}, {
		name: 'isHeavyTool',
		label: 'Is a heavy tool',
		type: SimpleFormPropertyType.Toggle,
	}];
	const {getFormData, resetFormData, handleFormFieldChange, hasFormChanged} = useSimpleForm<ResourceListItem>(EDIT_TOOL_FORM_TEMPLATE);

	useEffect(() => {
		if (item) {
			resetFormData(item);
		}
	}, [item]);

	const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		const formData = getFormData(e);
		onSubmit({...formData, id: item?.id});
		onClose();
	};

	return <Dialog open={open} onClose={onClose}>
		<DialogTitle>Edit tool</DialogTitle>
		<form onSubmit={handleSubmit}>
			<DialogContent>
				<Grid2 size={12} container spacing={1} alignContent='baseline'>
					{EDIT_TOOL_FORM_TEMPLATE.map((property) => <Grid2 key={property.name} size={12}>
						<SimpleFormField property={property} defaultValue={item?.[property.name]} onChange={handleFormFieldChange} />
					</Grid2>)}
				</Grid2>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Cancel</Button>
				<Button type='submit' disabled={!hasFormChanged} variant='contained'>Save</Button>
			</DialogActions>
		</form>
	</Dialog>;
}